import React from 'react';
import MainTitle from '../../components/page/main-title/MainTitle';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import TextInputWithUploader from '../../components/form/TextInputWithUploader';
import TextArea from "../../components/form/TextArea";
import Alert from "../../components/alert/Alert";
import SimpleAlert from "../../components/alert/types/SimpleAlert";
import STRINGS from './../../data/language/language';
import WS from '../../config/Ws';
import PAGES from '../../config/Pages';
import Requisitions from '../../utils/requisitions/Requisitions';
import Random from "../../utils/strings/Random";
import {FormDataToJson} from '../../utils/json/Json';
import Dialog from '../../components/alert/Dialog';

const URL_SAVE = WS.videos.save;

class Page extends React.Component{
  constructor (props){
    super(props);
    this.state = {
      wrapper:Random(7),
      strings:STRINGS[window.LANGUAGE],
      detalhe: props.detalhe
    }
    this.handleSubmit = this.handleSubmit.bind(this);

  }

  handleSubmit (e){
    const formData = new FormData(e.target);
    const nome = formData.get('nome');
    const masculino = formData.get('masculino');
    const feminino = formData.get('feminino');
    let modal = new Alert();
    var _self = this;
    const { salvoSucesso, msgCamposObrigatoriosVideos } = this.state.strings;

    var object = FormDataToJson(formData);
    //var dataSend = JSON.stringify(object);

    const {
      atencao,
      erroSalvarBloco,
      preenchaCamposAsterisco,
      escolhaOsExercicios,
      erroSalvar
    }
    = this.state.strings;

    if(nome !== '' && (masculino !== '' || feminino !== '')){
      Requisitions({
        url:URL_SAVE,
        data: object,
        sucess:function(data){
          var msg;
          _self.props.modal.close();
          _self.props.history.push(PAGES.videos);
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        },
        error:function(data){
          Dialog.create({
            title: atencao,
            text: erroSalvar
          });
        }
      });
    }else{
      let msg = {
        title: atencao,
        text:msgCamposObrigatoriosVideos
      };
      Dialog.create(msg);
    }

    e.preventDefault();
  }

  render (){

    const {
      titleCadastroVideos,
      fieldNome,
      fieldVideoMasculino,
      fieldVideoFeminino,
      fieldDigiteNome,
      observacoes,
      fieldDigiteAqui,
      salvar
    } = this.state.strings;

    const id = this.props.detalhe ? <input type='hidden' name='id' value={this.props.detalhe.id} />   : '';
    const nome = this.props.detalhe ? this.props.detalhe.nome : '';
    const video_masculino = this.props.detalhe ? this.props.detalhe.masculino : '';
    const video_feminino = this.props.detalhe ? this.props.detalhe.feminino : '';
    const observacoesVal = this.props.detalhe ? this.props.detalhe.observacoes : '';

    return (
      <div>
        <MainTitle title={titleCadastroVideos}></MainTitle>
        <form className="" onSubmit={this.handleSubmit}>
          {id}
          <div className="pure-u-3-5">
            <TextInput name="nome" value={nome} title={ fieldNome } placeholder={ fieldDigiteNome }></TextInput>
          </div>
          <div>
            <div className="pure-u-1-2">
              <TextInput name="masculino" value={video_masculino} title={ fieldVideoMasculino } placeholder={ fieldDigiteAqui }></TextInput>
            </div>
            <div className="pure-u-1-2">
              <TextInput name="feminino" value={video_feminino} title={ fieldVideoFeminino } placeholder={ fieldDigiteAqui }></TextInput>
            </div>
          </div>
          {/*
            <div>
              <div className="pure-u-1-2">
                <TextInputWithUploader value={video_masculino} name="masculino" title={ fieldVideoMasculino } placeholder=""></TextInputWithUploader>
              </div>
              <div className="pure-u-1-2">
                <TextInputWithUploader  value={video_feminino} key={Math.floor(Math.random()*100)} name="feminino" title={ fieldVideoFeminino } placeholder=""></TextInputWithUploader>
              </div>
            </div>
          */}

          <div className="">
            <TextArea value={observacoesVal} name="observacoes" title={observacoes} placeholder=""></TextArea>
          </div>
          <div className="box-right-button"><Button type="submit" text={ salvar } classes="bt-save bt-blue" /></div>
        </form>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/videos/Page.js